export const SAVE_CARD = 'SAVE_CARD';
export const GET_CARDS = 'GET_CARDS';
export const SET_CARDS = 'SET_CARDS';
export const SET_SELECTED_CARDS = 'SET_SELECTED_CARDS';

export interface PaymentCard {
  cid: string;
  card: string;
  expiry: string;
  cvc: string;
  cardtype: string;
  selected: boolean;
  user: string;
}

export interface Card {
  cards: PaymentCard[];
}

export interface SaveCardAction {
  type: typeof SAVE_CARD;
  card: PaymentCard;
}

export interface GetCardsAction extends Card {
  type: typeof GET_CARDS;
}

export interface SetCardsAction extends Card {
  type: typeof SET_CARDS;
  cards: PaymentCard[];
}

export interface SelectCardActions extends Card {
  type: typeof SET_SELECTED_CARDS;
  cid: string;
  selected: boolean;
}

export type CardsActionTypes =
  | SetCardsAction
  | GetCardsAction
  | SelectCardActions;
